import { isEmpty } from "lodash";
// components
import ContactForm from "@/components/ContactForm";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
// type
import { TMainPageLayoutV3 } from "../type";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import TopShape01 from "@/components/shapes/TopShape01";


type TRender = {
    languageVersion:TLanguageVersionList|TLanguageVersionDetail;
    languageVersions:TLanguageVersionList[]|TLanguageVersionDetail[];
}

const Render = ( props:TRender ) => {
    const { languageVersion, languageVersions } = props;

    return (
        <section className="section section-padding fix section-bg-3">
            <div className="container">
                <TopShape01 />
                <div className="contact-wrapper-4">
                    <div className="row g-4 align-items-end">
                        
                        <div className="col-12">
                            <div className="contact-content">
                                <RMDRComponentSanitizer languageVersion={languageVersion} variant="div" valueExpr="value" removeTag />
                                <ContactForm languageVersions={languageVersions} />
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
    )
}

const RenderTemplate = ( props:TMainPageLayoutV3 ) => {

    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions);

    if ( !props.template?.languageVersions || isEmpty(props.template?.languageVersions) || !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersions={props.template.languageVersions} 
        languageVersion={languageVersion} 
    />

}

const MNPG040 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG040.rendered: ", props);

    if ( !props.template || isEmpty(props.template) ) return null;
    return <RenderTemplate {...props} />

}

export default MNPG040;
